var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__part"},[_c('button',{class:[_vm.buttonDesign],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.formEl.subject))])])}
var staticRenderFns = []

export { render, staticRenderFns }